<script setup lang="ts">
import TelemetryView from '@/components/common/TelemetryView.vue'
</script>

<template>
  <TelemetryView :is-edge="true" />
</template>
